module.exports = __webpack_public_path__ + "img/onetimeIcon.08d18d56.svg";